import defaultReducer from './defaultReducer';

export const logInReducer = defaultReducer('FETCH_LOGIN', "");
export const logInSetReducer = defaultReducer('SET_PASSWORD', "OK");
export const logInResetReducer = defaultReducer('RESET_PASSWORD', "OK");
export const logOutReducer = defaultReducer('SET_LOGOUT', "");
